import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

function Header() {
  return (
    <AppBar
      position="static"  // 'static' verwenden, damit der Header im Inhaltsbereich bleibt
      sx={{
        backgroundColor: '#009be5',  // Kopfzeilenfarbe wie in der Demo
        boxShadow: 'none',  // Schatten entfernen
        borderRadius: 0,  // Keine runden Ecken
        width: '100%',  // Vollständige Breite innerhalb des Inhaltsbereichs
        margin: 0,  // Keine Außenabstände
        padding: '16px',  // Innenabstand für die Kopfzeile
      }}
    >
      <Toolbar disableGutters>  {/* Entfernt den inneren Abstand des Toolbars */}
        <Typography variant="h6" noWrap component="div">
          Paperbase Admin
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
